import script from "./psiOutStockGoods.vue?vue&type=script&setup=true&lang=js"
export * from "./psiOutStockGoods.vue?vue&type=script&setup=true&lang=js"

import "./psiOutStockGoods.vue?vue&type=style&index=0&id=c0981b12&scoped=true&lang=css"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0981b12"]])

export default __exports__